module.exports = __webpack_public_path__ + "img/om.537466c3.png";